import React from 'react'
import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 40,
  height: 31,
}

const bathtub = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...defaultSize, ...style }}
    viewBox='0 0 39.399 30.828'
  >
    <path
      fill={color}
      d='M39.429,17.868h-3.94a3.946,3.946,0,0,0-3.331-3.893,5.253,5.253,0,0,0-10.309-1.933,3.9,3.9,0,0,0-2.654.387,4.6,4.6,0,0,0-8.618,1.546,3.946,3.946,0,0,0-3.324,3.892H3.97a1.97,1.97,0,0,0,0,3.94h.657v7.223a5.914,5.914,0,0,0,5.428,5.886l1.172,3.515a.657.657,0,0,0,.622.449h2.627a.657.657,0,0,0,.622-.449l1.164-3.491H27.136L28.3,38.431a.657.657,0,0,0,.622.449h2.627a.657.657,0,0,0,.622-.449l1.172-3.515a5.914,5.914,0,0,0,5.428-5.886V21.807h.657a1.97,1.97,0,1,0,0-3.94ZM11.193,15.241a.657.657,0,0,0,.657-.657,3.283,3.283,0,0,1,6.422-.963.657.657,0,0,0,1.059.307,2.572,2.572,0,0,1,2.777-.423.657.657,0,0,0,.919-.548,3.939,3.939,0,1,1,7.7,1.456.657.657,0,0,0,.666.847,1.386,1.386,0,0,0,.169-.019,2.627,2.627,0,0,1,2.617,2.627H8.566a2.627,2.627,0,0,1,2.627-2.627Zm17.073,7.88v-3.94h5.253v3.94Zm5.253,1.313v1.313H28.266V24.434ZM3.97,20.494a.657.657,0,0,1,0-1.313H26.953v1.313Zm9.85,5.91a.657.657,0,0,1-1.313,0v-4.6h3.94v8.536a.657.657,0,0,1-1.313,0V26.4ZM14,37.567h-1.68l-.875-2.627h3.43Zm17.073,0H29.4l-.875-2.627h3.43Zm6.383-8.536a4.6,4.6,0,0,1-4.6,4.6H10.536a4.6,4.6,0,0,1-4.6-4.6V21.807h5.253v4.6a1.97,1.97,0,0,0,2.627,1.858v2.082a1.97,1.97,0,0,0,3.94,0V21.807h9.193v4.6a.657.657,0,0,0,.657.657h6.566a.657.657,0,0,0,.657-.657v-4.6h2.627Zm1.97-8.536h-4.6V19.181h4.6a.657.657,0,1,1,0,1.313Z'
      transform='translate(-2 -8.052)'
    />
  </svg>
)

export default bathtub
